import { Spinner } from '@heroui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`;

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #16a34a;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  animation: ${pulse} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

/** Zielone „Tłumaczenie...” ze spinnerem, gdy trigger backendu dorabia tłumaczenia (translationStatus = pending). */
export const TranslatingText: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <Wrap className={className}>
      <Spinner size="sm" />
      {t('events.translating', 'Tłumaczenie...')}
    </Wrap>
  );
};
